<script>
import { parallax } from "@/mixins/parallax";
import { viewport } from "@/mixins/viewport";

import ContentBox from "@/components/content/box/ContentBox";
import ContentRow from "@/components/content/row/ContentRow";
import ContentSplit from "@/components/content/split/ContentSplit";
import ContentSlider from "@/components/content/slider/ContentSlider";
import ContentFooter from "@/components/content/footer/ContentFooter";

export default {
  name: "TabPanel",
  mixins: [parallax, viewport],
  components: {
    ContentBox,
    ContentRow,
    ContentSplit,
    ContentSlider,
    ContentFooter
  },
  computed: {
    speeds() {
      return {
        background: this.viewport.mobile ? -0.25 : -0.5
      };
    }
  }
};
</script>
<style lang="stylus" scoped>
@import "TabPanel"
</style>
